var QRCode = require('qrcode')

class FormulasMenuCtrl {
  constructor($sce, $uibModal, $scope, $timeout, $window, UrlClipCopy, TBService, FlashService, AuthService, EventService, TemplateService, TemplateValidationService) {
    'ngInject';
    Object.assign(this, { $sce, $uibModal, $scope, $timeout, $window });

    this.tb = TBService;
    this.as = AuthService;
    this.fs = FlashService;
    this.ts = TemplateService;
    this.es = EventService;
    this.ucc = UrlClipCopy;
    this.tv = TemplateValidationService;

    this.modal;
    this.qrUrl = "";
    this.realm = null;
    this.allowPublish = true;
    this.showQbDashboardSignInLink = false;
  }

  async resolveDefaultTemplateLinkId(template) {
    let linkId = template.defaultTemplateLinkId;
    if (!linkId && template.signTemplate && template.id) {
      linkId = null;
    }
    return linkId;
  }

  async applyTemplateLinkTools(template) {
    const defaultTemplateLinkId = await this.resolveDefaultTemplateLinkId(template);
    const showTemplateLinkTools = !template.signTemplate || !!defaultTemplateLinkId;
    const submitUrl = template.signTemplate && defaultTemplateLinkId
      ? this.ucc.getUrlLinkUrl(template, defaultTemplateLinkId)
      : this.ucc.getAddUrl(template);
    const tmpUrl = await QRCode.toDataURL(submitUrl);
    const qrUrl = this.$sce.trustAsResourceUrl(tmpUrl);
    this.$timeout(() => {
      this.defaultTemplateLinkId = defaultTemplateLinkId;
      this.showTemplateLinkTools = showTemplateLinkTools;
      this.submitUrl = submitUrl;
      this.qrUrl = qrUrl;
    });
  }

  async $onInit() {
    [this.PROVIDER, this.realm, this.td] = await Promise.all([
      this.as.getProviderSettings(),
      this.as.realm(),
      this.ts.getTemplateData()
    ]);
    await this.applyTemplateLinkTools(this.td.template);

    this.es.subscribeEvent(
      this.es.actions.TEMPLATE_VALIDATED, 
      (results) => { 
        this.$timeout(() => { 
          // Only allows publishing anything when template is not unsaved and error level<danger
          this.allowPublish = results.SUMMARY.level.value !== this.tv.levels.DANGER.value;
        });
      }, 'TEMPLATE_VALIDATED_FORMULAMENU');

    this.es.subscribeEvent(
      this.es.actions.OPEN_DEFAULT_LINK_UPLOAD_CONFIG,
      (data) => this.$timeout(() => this.openDefaultLinkUploadConfig(data)),
      'OPEN_DEFAULT_LINK_UPLOAD_CONFIG_FORMULAMENU'
    );
  }

  async copyQrImage() {
    const filename = `Submit ${this.td.template.title} qr.png`;
    const url = await QRCode.toDataURL(this.submitUrl);
    this.ucc.copyImg(url, filename);
  }

  copyUrlToClip(action) {
    if (action === 'add' && this.showTemplateLinkTools && this.submitUrl) {
      this.ucc.copy(this.submitUrl);
      return;
    }
    this.ucc.copyToClipboard(action, this.td.template);
  }

  openFormUrl() {
    this.$window.open(this.submitUrl, '_blank');
  }

  blocksUnsignedLegacyPublish() {
    return this.td?.template?.signTemplate !== true && this.td?.template?.allowLegacyLinks !== true;
  }

  unsignedLegacyLinksMessage() {
    return 'This template needs to be saved as a new template to create new links (Smart Links) for it. Use "Save As", and then proceed using the new Smart Links button in this popup in that template.';
  }

  async openFormulas(action = '') {
    if (this.blocksUnsignedLegacyPublish()) {
      this.fs.warning(this.unsignedLegacyLinksMessage());
      return;
    }
    this.modal = this.$uibModal.open({
      template: `<formulas
                  action="'${action}'"
                  on-cancel="$ctrl.cancelModal()">
                </formulas>`,
      scope: this.$scope,
      size: 'xl',
      backdrop: 'static'
    });
    this.modal.result.then(
      closed => true,
      canceled => this.cancel()
    );
  }

  openDefaultLinkUploadConfig(data = {}) {
    const linkId = this.td?.template?.defaultTemplateLinkId;
    if (!linkId) {
      this.fs.error('No default link is configured for this template.');
      return;
    }
    if (this.ts.templateHasChanges(this.td?.template)) {
      return;
    }
    if (this.modal) {
      this.modal.dismiss('upload-config');
    }
    this._editLink = { linkId, type: 'url' };
    this._initialWizardStepId = 3;
    this._preselectUploadReferenceId = data?.referenceId || null;
    this.$scope.formulasMenuCtrl = this;
    this.$timeout(() => {
      this.modal = this.$uibModal.open({
        template: `<signed-template-link
                    edit-link="$ctrl._editLink"
                    initial-wizard-step-id="$ctrl._initialWizardStepId"
                    preselect-upload-reference-id="$ctrl._preselectUploadReferenceId"
                    on-cancel="$ctrl.cancelModal()">
                  </signed-template-link>`,
        scope: this.$scope,
        size: 'xlg',
        backdrop: 'static',
      });
      this.attachSignedLinkModalResult(this.modal);
    });
  }

  openSignedTemplateLink() {
    this._editLink = null;
    this._initialWizardStepId = null;
    this._preselectUploadReferenceId = null;
    this.$scope.formulasMenuCtrl = this;
    this.modal = this.$uibModal.open({
      template: `<signed-template-link
                  edit-link="$ctrl._editLink"
                  on-cancel="$ctrl.cancelModal()">
                </signed-template-link>`,
      scope: this.$scope,
      size: 'xlg',
      backdrop: 'static',
    });
    this.attachSignedLinkModalResult(this.modal);
  }

  dismissPublishedLinksModal(reason = 'navigate') {
    if (!this.modal) return;
    const modalInstance = this.modal;
    this.modal = null;
    modalInstance.dismiss(reason);
  }

  openSignedTemplateLinkFromList() {
    this.dismissPublishedLinksModal('new');
    this.$timeout(() => this.openSignedTemplateLink());
  }

  openSignedTemplateLinkForEdit(link) {
    if (link?.type === 'generate' || link?.type === 'import') return;
    this.dismissPublishedLinksModal('edit');
    this._editLink = link;
    this._initialWizardStepId = null;
    this._preselectUploadReferenceId = null;
    this.$scope.formulasMenuCtrl = this;
    this.$timeout(() => {
      this.modal = this.$uibModal.open({
        template: `<signed-template-link
                    edit-link="$ctrl._editLink"
                    initial-wizard-step-id="$ctrl._initialWizardStepId"
                    preselect-upload-reference-id="$ctrl._preselectUploadReferenceId"
                    on-cancel="$ctrl.cancelModal()">
                  </signed-template-link>`,
        scope: this.$scope,
        size: 'xlg',
        backdrop: 'static',
      });
      this.attachSignedLinkModalResult(this.modal);
    });
  }

  returnToLinksList() {
    this._editLink = null;
    const modalInstance = this.modal;
    this.modal = null;
    if (modalInstance) {
      modalInstance.dismiss('links');
    }
  }

  attachSignedLinkModalResult(modal) {
    modal.result.then(
      () => true,
      (reason) => {
        if (reason === 'links') {
          this.$timeout(() => this.openAssociatedLinks());
          return;
        }
        this.cancel();
      }
    );
  }

  async openWebhooks(hookType = '') {
    if (this.blocksUnsignedLegacyPublish()) {
      this.fs.warning(this.unsignedLegacyLinksMessage());
      return;
    }
    this.modal = this.$uibModal.open({
      template: `<${this.PROVIDER.prefix}-webhooks
                  hook-type="'${hookType}'"
                  on-cancel="$ctrl.cancelModal()">
                </${this.PROVIDER.prefix}-webhooks>`,
      scope: this.$scope,
      size: 'xl',
      backdrop: 'static'
    });
    this.modal.result.then(
      closed => true,
      canceled => this.cancel()
    );
  }

  async openAssociatedLinks() {
    this.modal = this.$uibModal.open({
      template: `<associated-template-links
                  template-id="$ctrl.td.template.id"
                  on-new-link="$ctrl.openSignedTemplateLinkFromList()"
                  on-edit-link="$ctrl.openSignedTemplateLinkForEdit(link)"
                  on-dismiss-list="$ctrl.dismissPublishedLinksModal()"
                  on-cancel="$ctrl.cancelModal()">
                </associated-template-links>`,
      scope: this.$scope,
      size: 'xlg',
      backdrop: 'static',
    });
    this.modal.result.then(
      () => true,
      (reason) => {
        if (reason === 'links' || reason === 'edit' || reason === 'new' || reason === 'navigate') return;
        this.cancel();
      }
    );
  }

  async publishPage() {
    const appId = this.td.template.appId;
    if (!appId) {
      this.fs.error('Please select an application.');
      return;
    }

    this.modal = this.$uibModal.open({
      template: `<build-page-confirm template="$ctrl.td.template" on-cancel="$ctrl.cancelModal()">
                </build-page-confirm>`,
      scope: this.$scope,
      size: 'md',
      backdrop: 'static',
      keyboard: false,
    });
    this.modal.result.then(
      closed => true,
      canceled => this.cancel()
    );
  }

  cancelModal() {
    this.modal.dismiss("Canceled");
  }

  cancel() {
    // Run anything needed when closing.
  }
}

export default {
  bindings: {
    unsaved: '<',
  },
  templateUrl: "form-builder/build-wizard/formulas-menu/formulas-menu.component.html",
  controller: FormulasMenuCtrl
}
